/*eslint-disable*/
import { Flex, Link, Text } from "@chakra-ui/react";
import React from "react";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "column",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as="span">
          Made by  
        </Text>
        <Link
          // color={linkTeal}
          color="teal.400"
          href="https://www.facebook.com/theKiddschool/"
          target="_blank"
          ml='2px'
        >
          โรงเรียนกวดวิชาคิดดี
        </Link>
      </Text>
      <Text color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >หมายเหตุ : ข้อสอบและแบบฝึกหัดในเว็บไซต์นี้จัดทำขึ้นเพื่อใช้ฝึกทักษะและพัฒนาการเรียนรู้ของผู้เรียน เนื้อหาบางส่วนพัฒนาจากแนวข้อสอบที่ใช้ในการสอบทั่วไป เพื่อให้ผู้เรียนได้ฝึกฝนตามลักษณะของข้อสอบจริง เว็บไซต์นี้ไม่ได้เผยแพร่ข้อสอบต้นฉบับจากโรงเรียน สถาบันการศึกษา หรือหน่วยงานใด และไม่มีความเกี่ยวข้องหรือได้รับการรับรองจากโรงเรียนหรือหน่วยงานเหล่านั้น ชื่อโรงเรียนหรือสถาบันที่ปรากฏในบางเนื้อหาใช้เพื่ออธิบายแนวข้อสอบเท่านั้น</Text>
    </Flex>
  );
}
